const hasNoSpace = (value: string) => /^\S*$/.test(value);

export default hasNoSpace;
